import React from 'react';
import { connect } from 'react-redux';
import * as S from './PlayButton.styles';
import * as T from './PlayButton.types';
import * as C from 'modules/Player/constants';
import * as SL from 'modules/Player/selectors';
import * as A from 'modules/Player/actions';

export class PlayButton extends React.PureComponent<T.IPlayButtonProps> {
  getIsDisabled = () => {
    const { showApiRequestErrorMessage, showId } = this.props;

    return showApiRequestErrorMessage.length > 0 || !Boolean(showId);
  };

  onPlayButtonToggle = () => {
    const {
      dispatchSetCurrentlyPlayingTrackId,
      dispatchTogglePlayStatus,
      currentlyPlayingTrackId,
      firstAvailableTrackIdInPlaylist,
    } = this.props;

    const isDisabled = this.getIsDisabled();

    if (isDisabled) {
      return;
    }

    if (!currentlyPlayingTrackId && firstAvailableTrackIdInPlaylist) {
      dispatchSetCurrentlyPlayingTrackId({
        id: firstAvailableTrackIdInPlaylist,
      });
    }

    dispatchTogglePlayStatus();
  };

  renderPause = () => {
    return (
      <svg id="pause" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="20" />
        <path d="M1136.99,1339.99v-10.97m6,10.97v-10.97" transform="translate(-1120 -1314)" />
      </svg>
    );
  };

  renderPlay = () => {
    return (
      <svg id="play" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="20" />
        <path d="M146.989,974.505l-10,6.489V968.016Z" transform="translate(-120 -954)" />
      </svg>
    );
  };

  render() {
    const { playStatus, showImageUrl } = this.props;

    return (
      <S.PlayButtonWrapper
        className={`noselect ${this.getIsDisabled() ? 'isDisabled' : ''}`}
        data-testid="PlayButton"
        onClick={this.onPlayButtonToggle}
        showImageUrl={showImageUrl}
        title={playStatus === C.PLAYING ? 'Pause' : 'Play'}
      >
        {playStatus === C.PLAYING ? this.renderPause() : this.renderPlay()}
      </S.PlayButtonWrapper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  showImageUrl: SL.getShowImageUrl(state),
  playStatus: SL.getPlayStatus(state),
  firstAvailableTrackIdInPlaylist: SL.getFirstAvailableTrackIdInPlaylist(state),
  currentlyPlayingTrackId: SL.getCurrentlyPlayingTrackId(state),
  currentlyPlayingTrackUrl: SL.getCurrentlyPlayingTrackUrl(state),
  showId: SL.getShowId(state),
  showApiRequestErrorMessage: SL.getShowApiRequestErrorMessage(state),
});

const mapDispatchToProps = {
  dispatchTogglePlayStatus: A.togglePlayStatus,
  dispatchSetCurrentlyPlayingTrackId: A.setCurrentlyPlayingTrackId,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayButton);
